import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';

export const paginationConfig = {
    size: 'sm' as 'sm' | 'lg' | '',
    boundaryLinks: false,
    ellipses: true,
    rotate: false,
    maxSize: 5,
    pageSize: 50,
};

export function ngbPaginationGlobalConfigFactory(): NgbPaginationConfig {
    const config = new NgbPaginationConfig();
    config.size = paginationConfig.size;
    config.boundaryLinks = paginationConfig.boundaryLinks;
    config.ellipses = paginationConfig.ellipses;
    config.rotate = paginationConfig.rotate;
    config.maxSize = paginationConfig.maxSize;
    config.pageSize = paginationConfig.pageSize
    return config;
}